import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRouteLetterA = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.85298 14H2.60298L6.69957 2.36364H9.30185L13.4041 14H11.1541L8.04616 4.75H7.95526L4.85298 14ZM4.92685 9.4375H11.0632V11.1307H4.92685V9.4375Z",
		fill: "#0070D4"
	})
});
export default SvgIconRouteLetterA;
